/**
 * Türkçe sözlük · grafik: Günlük Analiz (`screens/GrafikScreen.tsx`), hesap
 * karşılaştırması ve ölçüler (`components/GrafikKarsilastirma.tsx`), tarih
 * aralığı seçici ve hazır dönemler, yakınlaştırma düğmeleri, rapor para
 * birimi seçenekleri. Şekli bu dosya tanımlar; öteki diller ona bağlıdır.
 */
export const grafik = {
  baslik: "Günlük Analiz",
  aciklama: "Portföyün günlük seyri — her nokta o günün raporuyla aynı sayı.",
  paraBirimi: "Para birimi",
  gorunum: "Görünüm",
  tutarlar: "Tutarlar",
  getiriYuzdesi: "Getiri yüzdesi",
  tutarlarBaslik: (para: string) => `Tutarlar (${para})`,

  tarih: {
    baslik: "Tarih aralığı",
    ikiTarih: "İki tarihi de seçin.",
    sira: "Başlangıç tarihi bitişten sonra olamaz.",
    enCokGun: (n: number) => `Aralık en çok ${n} gün olabilir.`,
  },
  gecmisKilidi: (yil: number) => `${yil} yıldan eski fiyat geçmişi`,
  gecmisKilidiAciklama: "Başlangıcı daha yakın bir güne alın.",
  guncelleniyor: "Yeni fiyatlarla güncelleniyor…",
  bosBaslik: "Bu aralıkta değerlenecek bir şey yok",
  bosAciklama: "Kasada bu tarihlerde elde varlık ya da getiri doğuran hareket yok.",
  hesaplaniyor: (biten: number, toplam: number) => `Hesaplanıyor: ${biten} / ${toplam} gün`,

  /** Seri alanlarının adları (çizgi, seçili gün, karşılaştırma). */
  alan: {
    value: "Toplam varlık",
    cost: "Toplam maliyet",
    unrealizedGain: "Mevcut getiri",
    unrealizedGainRatio: "Mevcut getiri %",
    totalReturn: "Geçmiş dahil getiri",
    totalReturnRatio: "Geçmiş dahil getiri %",
  },

  seciliGun: "Seçili gün",
  bayatGun: "Bu günün değeri bayat bir ölçüme dayanıyor.",
  bayatOlcum: "bayat ölçüm",
  motorSoylemedi: "Motor bu değerin niçin olmadığını söylemedi — bu bir kusurdur, bildirin.",

  cizgi: {
    cizgiler: (baslik: string) => `${baslik}: çizgiler`,
    svgGun: (baslik: string, n: number) => `${baslik} — ${n} gün`,
    svgGorunen: (n: number) => `, görünen ${n} gün`,
    svgYardim: ". Seçili gün için ok tuşları; yakınlaştırmak için +, −, 0 ya da fareyle sürükleyin.",
  },

  yakinlastirma: {
    grup: (baslik: string) => `${baslik}: yakınlaştırma`,
    yakinlas: "Yakınlaştır",
    yakinlasBalon: "Yakınlaştır (+) — ya da grafikte sürükleyerek aralık seçin",
    uzaklas: "Uzaklaştır",
    uzaklasBalon: "Uzaklaştır (−)",
    tumunu: "Tümünü göster",
    tumunuBalon: "Tümünü göster (0)",
    tumu: "Tümü",
  },

  aralik: {
    tumTarihler: "Tüm tarihler",
    ozel: "Özel aralık",
    donem: "Dönem",
    baslangic: "Başlangıç",
    bitis: "Bitiş",
  },

  /** Hazır dönemler (`lib/tarihDonemleri.ts`). */
  donem: {
    bugun: "Bugün",
    dun: "Dün",
    buHafta: "Bu hafta",
    son1Hafta: "Son 1 hafta",
    gecenHafta: "Geçen hafta",
    buAy: "Bu ay",
    son1Ay: "Son 1 ay",
    gecenAy: "Geçen ay",
    son2Ay: "Son 2 ay",
    buCeyrek: "Bu çeyrek",
    son3Ay: "Son 3 ay",
    oncekiCeyrek: "Önceki çeyrek",
    buYariyil: "Bu yarıyıl",
    son6Ay: "Son 6 ay",
    gecenYariyil: "Geçen yarıyıl",
    buYil: "Bu yıl",
    son1Yil: "Son 1 yıl",
    gecenYil: "Geçen yıl",
    son2Yil: "Son 2 yıl",
    son3Yil: "Son 3 yıl",
    son4Yil: "Son 4 yıl",
    son5Yil: "Son 5 yıl",
    son10Yil: "Son 10 yıl",
  },

  /** Rapor / grafik para birimi seçenekleri (`lib/raporParaBirimi.ts`). */

  kars: {
    butunKasa: "Bütün kasa",
    sanal: (ad: string) => `${ad} (sanal)`,
    sanalTemettuHaric: (ad: string) => `${ad} (sanal, temettü hariç)`,
    karsilastirilan: "Karşılaştırılan",
    baslik: (ad: string) => `Karşılaştırma: ${ad}`,
  },

  olcu: {
    baslik: "Ölçüler",
    aciklama:
      "Zaman ağırlıklı: para yatırmak/çekmek getiri sayılmaz. Oynaklık yıllık (√365). Risksiz faize göre ölçüler " +
      "mevduat serisi gelince.",
    kiyas: "Kıyas",
    kiyasYok: "Kıyas yok",
    altin: "Altın (ons)",
    dolar: "Dolar",
    euro: "Euro",
    motorSebep: "Motor sebebini söylemedi.",
    kismi: " (kısmi)",
    hesaplaniyor: "Ölçüler hesaplanıyor…",
    hata: (mesaj: string) => `Ölçüler hesaplanamadı: ${mesaj}`,
    hesap: "Hesap",
    getiri: "Getiri",
    enBuyukDusus: "En büyük düşüş",
    enIyiYil: "En iyi yıl",
    enKotuYil: "En kötü yıl",
    enIyiAy: "En iyi ay",
    enKotuAy: "En kötü ay",
    oynaklik: "Oynaklık",
    kiyasaFark: "Kıyasa fark",
    derlemedeYok: "Bu derlemede ölçü yok.",
    toparlanmadi: "toparlanmadı",
    toparlandi: (tarih: string) => `toparlandı ${tarih}`,
    kiyasEtiket: "kıyas",
  },
};
